import { i18n } from "@/utils/i18n";

export default {
  namespaced: true,
  state: {
    endpoint: "/client/custom/lamcom/hive/work_orders/",
    key: "work_order",
    permissionKey: ""
  },
  mutations: {},
  actions: {},
  getters: {}
};
